<template>
  <div>
    <PageSwitch :currentTimeTag.sync="currentTimeTag" :allTimes="allTimes" :storeInfo="storeInfo"
      :equipments="equipments" v-model="currentTime" :disabledDate="disabledTime" @updateEq="updateEq" />
    <component v-if="currentTime" :tagTrusted="tagTrusted" :disabledDate="disabledTime" :currentTimeTag.sync="currentTimeTag" :allTimes="allTimes"
      :lasteTimeTag="lasteTimeTag" :is="pageType[type]" :storeInfo="storeInfo" :currentEqs="equipments"
      :currentEqPois="currentEqPois" :allCurrnetPo="allCurrnetPo" true :equipments="dayEq" :eqPoints="eqPoints"
      :allPonits="allPonits" :isRequestPoint="isRequestPoint" :pointsRes="pointsRes"
      :storeBugNum="storeBugNum" :date="currentTime"></component>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import PageSwitch from '../../components/warestore/pageSwitch'
import Summary from '../../components/warestore/summary'
import Compared from '../../components/warestore/compared'
import Curve from '../../components/warestore/curve'
import Report from '../../components/warestore/report'
import moment from 'moment'
const list = [
  {
    name: '象甲科(米象、玉米象等)',
    num: '--'
  },
  {
    name: '拟步甲科等(谷盗等)',
    num: '--'
  },
  {
    name: '飞蚁科',
    num: '--'
  },
  {
    name: '飞蛾科',
    num: '--'
  },
  {
    name: '飞蛾幼虫类',
    num: '--'
  },
  {
    name: '未识别害虫',
    num: '--'
  }
]
export default {
  components: {
    PageSwitch
  },
  data () {
    return {
      tagTrusted: true,
      currentTimeTag: '',
      allTimes: [],
      currentTime: null,
      maxTime: null,
      minTime: null,
      // 粮库信息
      storeInfo: {},
      equipments: [],
      currentEqPois: [],
      // 每日统计信息
      dayEq: [],
      eqPoints: [],
      storeBugNum: 0,
      isRequestPoint: true,
      pointsRes: [],
      pageType: {
        summary: Summary, // 汇总
        report: Report, // 报表
        curve: Curve, // 曲线
        compared: Compared // 数据对比
      }
    }
  },
  watch: {
    currentTime () {
      // 获取当前选定日期的所有设置
      this.getDateRelatedData()
    },
    currentTimeTag (newV) {
      if (newV) {
        this.tagTrusted = true
        this.getAllData()
      }
    }
  },
  computed: {
    lasteTimeTag () {
      if (this.allTimes.length > 0) {
        return this.allTimes[this.allTimes.length - 1]
      } else {
        return undefined
      }
    },
    type () {
      return this.$route.query.type
    },
    storeId () {
      return this.$route.query.store
    },
    allCurrnetPo () {
      const arr = []
      let index = 1
      for (let i = 0; i < this.currentEqPois.length; i++) {
        const element = this.currentEqPois[i]
        for (let j = 0; j < element.points.length; j++) {
          const point = element.points[j]
          this.$set(point, 'index', index++)
          arr.push(point)
        }
      }
      return arr
    },
    allPonits () {
      const arr = []
      let index = 1
      for (let i = 0; i < this.eqPoints.length; i++) {
        const element = this.eqPoints[i]
        for (let j = 0; j < element.points.length; j++) {
          const point = element.points[j]
          this.$set(point, 'index', index++)
          arr.push(point)
        }
      }
      return arr
    }
  },
  beforeDestroy () {
    // this.
    this.setPageTitle('')
  },
  methods: {
    ...mapMutations(['setPageTitle']),
    // ------- 组件props -------
    disabledTime (date) {
      if (this.minTime) {
        if (date.isBefore(this.maxTime) && date.isAfter(this.minTime)) {
          return false
        } else {
          return true
        }
      } else {
        return true
      }
    },
    // -------- 组件emit ------
    async updateEq () {
      // 获取所有摄像头
      await this.getEquipments()
      // // 获取所有点位
      // await this.getAllPoint(this.equipments)
      // // 获取所有统计信息
      // this.getAllData()
    },
    // --------  -----
    async init () {
      // 获取当前粮仓的所有的设置
      this.getStroeRelatedData()
    },
    async getStroeRelatedData () {
      // 获取粮仓的信息
      this.getStore()
      // 获取粮仓下属的摄像头信息
      this.getEquipments()
      // 获取粮仓的记录范围
      this.getStoreRecordRange()
    },
    // ---------- 实时信息 -----------
    // 获取当前粮仓的数据
    async getStore () {
      const res = await this.$tkParse.get(
        `/classes/grainStorehouse/${this.storeId}`
      )
      this.storeInfo = res.data
      this.setPageTitle(this.storeInfo.name)
    },
    // 获取粮仓下的当前的摄像头的数据
    async getEquipments () {
      const res = await this.$tkParse.get('/classes/equipment', {
        params: {
          where: { grainstore: this.storeId },
          order: 'createdAt',
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      this.equipments = res.data.results
      this.getCurrentPoint(this.equipments)
    },

    // 获取当前的点位信息
    async getCurrentPoint (equipments) {
      const promises = []
      equipments.forEach(element => {
        const ajax = this.$tkParse.get('/classes/dropPlace', {
          params: {
            where: { eqId: element.objectId },
            limit: Number.MAX_SAFE_INTEGER
          }
        })
        promises.push(ajax)
      })
      const pointsarr = await Promise.all(promises)
      const eqPoints = pointsarr.map((element, index) => {
        return {
          eqId: equipments[index].objectId,
          eqinfo: equipments[index],
          points: element.data.results
        }
      })
      this.currentEqPois = eqPoints
    },

    // ------------ 记录信息 -----------------
    async getStoreRecordRange () {
      try {
        const res = await this.$tkParse.get('/aggregate/dayStore', {
          params: {
            match: {
              originalId: this.storeId
            },
            group: {
              objectId: '', // 用来分组的字段，留空代表不分组
              max: { // total是自定义的名称，你可以用任何名字
                $max: '$date' // 字段名前加$表示一个字段,这里将统计所有该字段的总和
              },
              min: {
                $min: '$date'
              }
            }
          }
        })
        const data = res.data.results
        if (data.length > 0 && data[0].max) {
          this.maxTime = moment(data[0].max).endOf('day')
          this.minTime = moment(data[0].min).startOf('day')
          this.currentTime = moment(data[0].max)
        } else {
          this.maxTime = moment()
          this.minTime = moment().subtract(60, 'seconds')
        }
      } catch (e) {
        console.log(e)
      }
    },
    // 根据日期获取对应的数据
    async getDateRelatedData () {
      this.isRequestPoint = true
      this.currentTimeTag = undefined
      this.dayEq = await this.getDayEq()
      this.eqPoints = await this.getAllPoint(this.dayEq)
      await this.getDateTimes()
      // this.getAllData()
    },
    // 获取对应日期下的可选的时间点
    async getDateTimes () {
      const res = await this.$tkParse.get('/classes/dayStore', {
        params: {
          where: {
            originalId: this.storeId,
            date: {
              $gt: moment(this.currentTime)
                .startOf('day')
                .toISOString(),
              $lte: moment(this.currentTime)
                .endOf('day')
                .toISOString()
            }
          }
        }
      })
      const times = res.data.results[0].times
      this.allTimes = times.split('@')
      this.currentTimeTag = this.allTimes[this.allTimes.length - 1]
      this.getPointResultIsTrusted(this.currentTimeTag)
    },
    // 获取时间点下数据是否可信
    async getPointResultIsTrusted (currentTimeTag) {
      const res = await this.$tkParse.get('/classes/mistrustTimeTag', {
        params: {
          where: {
            storeId: this.storeId,
            date: {
              $gt: moment(this.currentTime)
                .startOf('day')
                .toISOString(),
              $lte: moment(this.currentTime)
                .endOf('day')
                .toISOString()
            },
            tag: currentTimeTag
          }
        }
      })
      if (res.data.results.length > 0) { this.tagTrusted = false } else this.tagTrusted = true
    },
    // 获取对应日期下的摄像头的数据
    async getDayEq () {
      const res = await this.$tkParse.get('/classes/dayEq', {
        params: {
          where: {
            grainstore: this.storeId,
            date: {
              $gt: moment(this.currentTime)
                .startOf('day')
                .toISOString(),
              $lte: moment(this.currentTime)
                .endOf('day')
                .toISOString()
            }
          },
          limit: Number.MAX_SAFE_INTEGER
        }
      })
      return res.data.results
    },
    // 获取对应日期下的点位数据
    async getAllPoint (equipments) {
      const promises = []
      equipments.forEach(element => {
        const ajax = this.$tkParse.get('/classes/dayDrop', {
          params: {
            where: {
              eqId: element.originalId,
              date: {
                $gt: moment(this.currentTime)
                  .startOf('day')
                  .toISOString(),
                $lte: moment(this.currentTime)
                  .endOf('day')
                  .toISOString()
              }
            },
            limit: Number.MAX_SAFE_INTEGER
          }
        })
        promises.push(ajax)
      })
      const pointsarr = await Promise.all(promises)
      const eqPoints = pointsarr.map((element, index) => {
        return {
          eqId: equipments[index].originalId,
          eqinfo: equipments[index],
          points: element.data.results
        }
      })
      return eqPoints
    },
    getAllData () {
      this.getAllpointResults()
    },
    async getAllpointResults () {
      this.isRequestPoint = true
      const mission = await this.$tkParse.get('/classes/mission', {
        params: {
          where: {
            time: this.currentTimeTag,
            storeId: this.storeId,
            date: {
              $gt: moment(this.currentTime)
                .startOf('day')
                .toISOString(),
              $lte: moment(this.currentTime)
                .endOf('day')
                .toISOString()
            }
          }
        }
      })
      const missionId = mission.data.results[0].objectId

      const res = await this.$tkParse.get('/classes/testResults', {
        params: {
          where: {
            mission: missionId
          },
          limit: 1000
        }
      })
      const testResults = res.data.results

      // const promises = this.allPonits.map(element => {
      //   const params = {
      //     where: {
      //       time: this.currentTimeTag,
      //       drop: element.originalId,
      //       date: {
      //         $gt: moment(this.currentTime)
      //           .startOf('day')
      //           .toISOString(),
      //         $lte: moment(this.currentTime)
      //           .endOf('day')
      //           .toISOString()
      //       }
      //     }
      //   }
      //   return this.$tkParse.get('/classes/testResults', {
      //     params: params,
      //     limit: Number.MAX_SAFE_INTEGER
      //   })
      // })
      // const res = await Promise.all(promises)
      let bugCount = 0
      // let passCount = 0
      this.pointsRes = this.allPonits.map((point, index) => {
        let result
        const testResult = testResults.find(item => item.drop === point.originalId)
        if (testResult) {
          result = {
            hasResult: true,
            ...this.allPonits[index],
            list,
            img: testResult.images[0],
            point: `${this.allPonits[index].index}号点位`,
            count: testResult.bugNum,
            ...testResult
          }
        } else {
          result = {
            hasResult: false,
            ...this.allPonits[index],
            list,
            point: `${this.allPonits[index].index}号点位`,
            count: 0
          }
        }
        this.$set(this.allPonits[index], 'test', result)
        return result
      })
      // // 如果所有点位均检测失败，则不显示页面数据
      // if (passCount === res.length) {
      //   if (this.tagTrusted) this.tagTrusted = false
      // }
      this.storeBugNum = bugCount
      this.isRequestPoint = false
    }
  },
  created () {
    this.init()
  }
}
</script>
<style></style>
